export type Code = `+${number | string}`;

export type CountryConfig = {
  flag: string;
  code: Code;
  name: string;
  mask?: string;
};

export const countryList: CountryConfig[] = [
  { flag: "🇷🇺", code: "+7", name: "Россия", mask: "___ ___-__-__" },
  { flag: "🇰🇿", code: "+7", name: "Казахстан", mask: "___ ___-__-__" },
  { flag: "🇧🇾", code: "+375", name: "Беларусь", mask: "__ ___ __ __" },
  { flag: "🇺🇸", code: "+1", name: "США", mask: "___ ___-____" },
  { flag: "🇬🇧", code: "+44", name: "Великобритания", mask: "____ _____" },
  { flag: "🇩🇪", code: "+49", name: "Германия", mask: "___ _______" },
  { flag: "🇫🇷", code: "+33", name: "Франция", mask: "_ __ __ __ __" },
  { flag: "🇮🇹", code: "+39", name: "Италия", mask: "___ ______" },
  { flag: "🇪🇸", code: "+34", name: "Испания", mask: "___ ___ ___" },
  { flag: "🇹🇷", code: "+90", name: "Турция", mask: "___ ___ __ __" },
  { flag: "🇨🇳", code: "+86", name: "Китай", mask: "___ ____ ____" },
  { flag: "🇯🇵", code: "+81", name: "Япония", mask: "___ ____ ____" },
  { flag: "🇮🇳", code: "+91", name: "Индия", mask: "_____ _____" },
  { flag: "🇦🇲", code: "+374", name: "Армения", mask: "__ ______" },
  { flag: "🇦🇿", code: "+994", name: "Азербайджан", mask: "__ ___ __ __" },
  { flag: "🇬🇪", code: "+995", name: "Грузия", mask: "___ ___ ___" },
  { flag: "🇰🇬", code: "+996", name: "Киргизия", mask: "___ ___ ___" },
  { flag: "🇹🇯", code: "+992", name: "Таджикистан", mask: "__ ___ __ __" },
  { flag: "🇺🇿", code: "+998", name: "Узбекистан", mask: "__ ___ __ __" },
];
